export default __webpack_public_path__ + "static/media/PRA_Walk_Loop-v2.02fbf637.wav";